<template>
  <div ref="filterMaster" class="filterMaster">
    <form class="ui form" @submit.prevent="searchParcel_2">
      <div class="field" id="idEstilo" v-if="options.showPhone">
        <sui-input  placeholder="Teléfono" icon="phone" v-model="search.phone" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showMultiorderCode">
        <sui-input placeholder="Nº Pedido" icon="barcode" v-model="search.multiorder_code" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showEmail">
        <sui-input placeholder="Email" icon="mail" v-model="search.email" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showName">
        <sui-input placeholder="Nombre" icon="user" v-model="search.name" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showSearchAllCodes">
        <sui-input placeholder="Barcode, RefCode, ParcelId, OpenCode, DropoffCode, MultiorderCode" icon="barcode" v-model="search.codigo" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showCode">
        <sui-input placeholder="Código" icon="barcode" v-model="search.codigo" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showComboClient">
        <sui-dropdown fluid multiple search :options="clientsOptions" placeholder="Clientes" selection v-model="search.client" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showComboCountry">
        <sui-dropdown fluid multiple search :options="countryOptions" placeholder="País" selection v-model="search.country" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showComboApm">
        <sui-dropdown fluid multiple search :options="apmsOptions" placeholder="Máquinas" selection v-model="search.apm" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showComboStatus">
        <sui-dropdown fluid multiple search :options="statusOptions" placeholder="Estados" selection v-model="search.status" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showDateIni">
        <sui-input onfocus="(this.type='date')"  onblur="(this.type='text')" icon='calendar' placeholder="Fecha Inicio" v-model="search.startDate" />
      </div>
      <div class="field" id="idEstilo" v-if="options.showDateEnd">
        <sui-input onfocus="(this.type='date')" onblur="(this.type='text')" icon='calendar' placeholder="Fecha Fin" v-model="search.endDate" />
      </div> 

      <div class="field" style="width: 70%; margin:auto">
        <button class="ui button fluid" type="submit">Buscar</button>
      </div>
    </form>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'filterMaster',
  props: ['theRole'],
  data() {
      return {
        role: null,
         search: {
          'phone': null,
          'email': null,
          'codigo': null,
          'status': null,
          'name': null,
          'client': null,
          'apm': null,
          'startDate': null,
          'endDate': null,
        },
        clientsOptions: [],
        apmsOptions: [],
        countryOptions: [],
        servicesOptions: [],
        statusOptions: [],
        options: {
          'showPhone': false,
          'showMultiorderCode': false,
          'showEmail': false,
          'showSearchAllCodes': false,
          'showCode': false,
          'showName': false,
          'showComboClient': false,
          'showComboApm': false,
          'showComboCountry': false,
          'showComboStatus': false,
          'showDateIni': false,
          'showDateEnd': false,
        }
      }
  },
  created() {
    this.role = this.theRole;
    this.showFilterOptions()
    this.getDataFilters()
  },
  methods: {
    showFilterOptions (){
      if (this.role === 'cau') {
        document.documentElement.style.setProperty('--n_filter_column', 2);
        this.options.showMultiorderCode  = true
        this.options.showPhone  = true
      } else if (this.role === 'admin' || this.role === 'master') {
        document.documentElement.style.setProperty('--n_filter_column', 4);
        this.options.showPhone  = true
        this.options.showEmail  = true
        this.options.showSearchAllCodes  = true
        this.options.showName  = true
        this.options.showComboClient  = true
        this.options.showComboApm  = true
        this.options.showComboCountry  = true
        this.options.showComboStatus  = true
        this.options.showDateIni  = true
        this.options.showDateEnd  = true
      } else if (this.role === 'sabico') {
        document.documentElement.style.setProperty('--n_filter_column', 3);
        this.options.showPhone  = true
        this.options.showEmail  = true
        this.options.showCode  = true
      } else if (this.role === 'clientApi') {
        document.documentElement.style.setProperty('--n_filter_column', 3);
        this.options.showPhone  = true
        this.options.showCode  = true
        this.options.showComboApm  = true
        this.options.showComboStatus  = true
        this.options.showDateIni  = true
        this.options.showDateEnd  = true
      } else {
        document.documentElement.style.setProperty('--n_filter_column', 3);
        this.options.showPhone  = true
        this.options.showEmail  = true
        this.options.showCode  = true
        this.options.showComboStatus  = true
        this.options.showDateIni  = true
        this.options.showDateEnd  = true
      }
    },
    searchParcel_2() {
      for (const value in this.search) {
        if (this.search[value] === null || this.search[value] == 0) {
          delete this.search[value]; //Quitamos del array los filtros que no hayamos utilizado cuando pulsemos el btn 'buscar'
        }
      }
      this.$emit('filtersSelected', this.search);
    },
    async getDataFilters() {
      let body = {
        admin_id: JSON.parse(localStorage.admin).id,
      }
      if (this.options.showComboClient) {
        body.HapiickClient = true
      }
      if (this.options.showComboApm) {
        body.Apt = true
      } 
      if (this.options.showComboStatus) {
        body.Status = true
      }
      if (this.options.showComboCountry) {
        body.Country = true
      }

      await hapiickApi().post('/v2/shipments/filters', body)
      .then(request => {
        if (this.options.showComboClient) {
          this.fillClientsOptions(JSON.parse(JSON.stringify(request.data.data.clients)))
        }
        if (this.options.showComboApm) {
          this.fillApmsOptions(JSON.parse(JSON.stringify(request.data.data.apms)))
        } 
        if (this.options.showComboStatus) {
          this.fillStatusOptions(JSON.parse(JSON.stringify(request.data.data.status)))
        }
        if (this.options.showComboCountry) {
          this.fillCountryOptions(JSON.parse(JSON.stringify(request.data.data.country)))
        }
      })
      .catch(() => console.log('error getting clients and apms'))
    },
    fillStatusOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.statusOptions.push({
          key: data[i].key,
          text: data[i].text,
          value: data[i].value
        })
      }
    },
    fillClientsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.clientsOptions.push({
          key: data[i].HapiickClient.id,
          text: data[i].HapiickClient.name,
          value: data[i].HapiickClient.id
        })
      }
    },
    fillApmsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.apmsOptions.push({
          key: data[i].Apt.id,
          text: data[i].LanguagesApts[0].name,
          value: data[i].Apt.place_id
        })
      }
    },
    fillCountryOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.countryOptions.push({
          key: data[i].Country.id,
          text: data[i].Country.name,
          value: data[i].Country.id
        })
      }
    },
  }
}
</script>
<style scoped>
  form {
    display: block;
  }

  #idEstilo {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
     form {
      display: flex;
      flex-wrap: wrap;
    }

    #idEstilo {
      width: calc(100% / var(--n_filter_column));
      padding: 5px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/filterMaster.vue